module.exports = __webpack_public_path__ + "static/img/top.b57a1461.png";